import { render, staticRenderFns } from "./ListLives.vue?vue&type=template&id=6f3a2820&"
import script from "./ListLives.vue?vue&type=script&lang=js&"
export * from "./ListLives.vue?vue&type=script&lang=js&"
import style0 from "./ListLives.vue?vue&type=style&index=0&id=6f3a2820&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports